import { ThemeProvider } from '@material-ui/core';
import { CookiesProvider } from 'react-cookie';

import Context from '#root/Context';
import RouterConfig from '#root/navigation/RouterConfig';
import theme from '#root/theme';
import '#root/styles/index.scss';
import ToastNotification from '#root/components/ToastNotification/ToastNotification';
import { ToastQueueProvider } from '#root/contexts/ToastContext';

const App = () => {
  return (
    <CookiesProvider>
      <ToastQueueProvider>
        <Context.Provider>
          <ThemeProvider theme={theme}>
            <RouterConfig />
            <ToastNotification />
          </ThemeProvider>
        </Context.Provider>
      </ToastQueueProvider>
    </CookiesProvider>
  );
};

export default App;
